




































































































import { Component, Watch, Prop, Ref } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { cloneDeep, merge } from 'lodash'
import UserDetailUserInfo from '@/components/templates/user-detail/UserDetailUserInfo.vue'
import ReserveReserveInfo from '@/components/organisms/ReserveReserveInfo/ReserveReserveInfo.vue'
import ReserveListTable from '@/components/organisms/ReserveListTable/ReserveListTable.vue'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  Alert,
  AlertMessage,
  collectionApi,
  defaultSystemCode,
  DeleteReserveExpirationRequest,
  ErrorMessage,
  reserveApi,
  ReserveCollection,
  SimpleCollection,
  SystemCode,
  UpdateReserveExpirationRequest
} from '@/api'
import {
  alertStore,
  authUserStore,
  modalErrorStore,
  systemCodeStore,
  systemParameterStore
} from '@/utils/store-accessor'
import { AlertFactory } from '@/factory'
import { ModalReserveCancel } from '@/components/modals/ModalReserveCancel'
import { ModalReserveRank } from '@/components/modals/ModalReserveRank'
import {
  InputReserveItem,
  defaultInputReserveItem
} from '@/components/organisms/ReserveReserveInfo'
import dayjs from 'dayjs'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { ReservedCollectionsTable } from '@/components/organisms/ReservedCollectionsTable'
import { CODE_KEY } from '@/config'
import {
  AlertCodeAL300051,
  AlertCodeALC00012,
  AlertCodeTL700020,
  defaultUserDetailStateInfo,
  UserDetailStateInfo
} from '@/types'
import { ModalForwardingRequest } from '@/components/modals/ModalForwardingRequest'
import { ModalForwardingRequestConfirm } from '@/components/modals/ModalForwardingRequestConfirm'
import {
  UserDetailUserInfoItem,
  defaultUserDetailUserInfoItem
} from '@/components/templates/user-detail'
import { InputCollectionNo } from '@/components/molecules/InputCollectionNo'

export interface ModalSimpleReserveInterface {
  id: string
  info: UserDetailUserInfoItem
  contactMethod: SystemCode
  onUpdated: Function
}

interface ModalSimpleReserveInputCollectionNo {
  input: string
  errorMessage: string
}

const defaultModalSimpleReserveInputCollectionNo = (): ModalSimpleReserveInputCollectionNo => ({
  input: '',
  errorMessage: ''
})

@Component({
  components: {
    InputCollectionNo,
    UserDetailUserInfo,
    ReserveReserveInfo,
    ReserveListTable,
    ReservedCollectionsTable,
    ModalReserveCancel,
    ModalForwardingRequest,
    ModalForwardingRequestConfirm,
    ModalReserveRank,
    ModalFooter
  }
})
export default class ModalSimpleReserve extends ModalComponentBaseVue {
  @Ref()
  inputCollectionNo!: InputCollectionNo

  @Ref()
  modalReserveCancel!: ModalReserveCancel

  @Ref()
  modalForwardingRequest!: ModalForwardingRequest

  @Ref()
  modalForwardingRequestConfirm!: ModalForwardingRequestConfirm

  @Ref()
  modalReserveRank!: ModalReserveRank

  @Prop({
    type: Array,
    required: true
  })
  reserveCollections!: ReserveCollection[]

  dialog: boolean = false

  updatedCallback: Function = () => {}

  userId: string = ''

  infoItem: UserDetailUserInfoItem = defaultUserDetailUserInfoItem()

  state: UserDetailStateInfo = defaultUserDetailStateInfo()

  inputReserve: InputReserveItem = defaultInputReserveItem()

  collectionNo: ModalSimpleReserveInputCollectionNo = defaultModalSimpleReserveInputCollectionNo()

  inputCollectionId?: number

  tableBodyHeight: number = 0

  reserveCancelCollections: ReserveCollection[] = []

  forwardingRequestAlerts: Alert[] = []

  inputCollectionBibliographyRealId: number = 0

  get forwardingRequestEnable(): boolean {
    return systemParameterStore.forwardingRequestEnable
  }

  @Watch('dialog')
  initialize(): void {
    if (this.dialog) {
      this.$nextTick(this.calculateTableHeight)
      return
    }

    this.tableBodyHeight = 0
  }

  @Watch('dialog')
  onShowChanged(val: boolean) {
    val ? this.opened() : this.closed()
  }

  mounted() {
    this.debug('mounted()')
    window.addEventListener('resize', this.onResize)
  }

  beforeDestroy() {
    this.debug('beforeDestroy()')
    window.removeEventListener('resize', this.onResize)
  }

  open(params: ModalSimpleReserveInterface): void {
    this.userId = params.id
    this.infoItem = params.info
    this.updatedCallback = params.onUpdated

    this.init()

    systemCodeStore.fetchAllAndMergeByCodeKeys([
      CODE_KEY.USER_STATUS.KEY,
      CODE_KEY.PROCESSING_PLACE.KEY
    ])
    systemParameterStore
      .fetchAllAndMergeByCodeKeys([
        CODE_KEY.NUMBER_MANAGEMENT.KEY,
        CODE_KEY.RESERVE_CONTACT_METHOD_DEFAULT_VALUE_SETTING.KEY,
        CODE_KEY.RESERVE_FORWARDING_ENABLED_SETTING.KEY,
        CODE_KEY.MOBILE_LIBRARY_PROCESSING_PLACE.KEY,
        CODE_KEY.RESERVE_METHOD_PRESET_SETTING.KEY,
        CODE_KEY.RESERVE_SPECIFY_BRANCH_CODE_DEFAULT_SETTING.KEY
      ])
      .then(() => {
        this.inputReserve.reserveMethod.input =
          systemParameterStore.reserveMethodPresetValue
        this.inputReserve.reserveSpecifyBranch.input =
          systemParameterStore.defaultReserveSpecifyBranchCodes

        if (systemParameterStore.contactMethodDefaultValue !== '') {
          this.inputReserve.contactMethod.input =
            systemCodeStore.findByCodeKeyAndCode(
              CODE_KEY.RESERVE_CONTACT_METHOD_SETTING.KEY,
              systemParameterStore.contactMethodDefaultValue
            ) ??
            merge(defaultSystemCode(), {
              codeKey: CODE_KEY.RESERVE_CONTACT_METHOD_SETTING.KEY,
              code: systemParameterStore.contactMethodDefaultValue
            })
        } else {
          this.inputReserve.contactMethod.input = params.contactMethod
        }
      })

    this.dialog = true
  }

  close(): void {
    this.dialog = false
  }

  init() {
    this.collectionNo = defaultModalSimpleReserveInputCollectionNo()
    this.inputCollectionId = undefined
    this.inputReserve = defaultInputReserveItem()
    this.inputReserve.reserveBranch.input = cloneDeep(
      authUserStore.authUser.branchCode
    )
    this.inputReserve.reservePlace.input = cloneDeep(
      authUserStore.authUser.placeCode
    )
    this.inputReserve.forwardingBranch.input = cloneDeep(
      authUserStore.authUser.branchCode
    )
    this.inputReserve.reserveRegistrationDate.input = dayjs().format('YYYYMMDD')
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  resetInputCollectionNo() {
    this.collectionNo = defaultModalSimpleReserveInputCollectionNo()
    this.inputCollectionId = undefined
    this.inputCollectionNo.focus()
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-simple-reserve')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onResize(): void {
    this.calculateTableHeight()
  }

  onInputCollectionNo(value: string) {
    this.collectionNo.input = value
    this.collectionNo.errorMessage = ''
    this.inputCollectionId = undefined
  }

  onClickDeleteReserve(id: number): void {
    const alert: Alert = AlertFactory.create(AlertCodeAL300051)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        this.reserveCancelCollections = [
          this.reserveCollections.find(item => item.id === id)!
        ]
        this.modalReserveCancel.open({
          reserveCancelCollections: this.reserveCancelCollections.map(value => {
            return {
              reserveId: value.id,
              revision: value.revision
            }
          }),
          onReserveCanceled: () => {
            this.updatedCallback()
            this.reserveCancelCollections = []
          }
        })
      }
    })
  }

  async onClickDeleteReserveExpiration(index: number) {
    const request: DeleteReserveExpirationRequest = {
      id: this.reserveCollections[index].id,
      revision: this.reserveCollections[index].revision
    }

    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await reserveApi.deleteReserveExpiration(request)
      await this.updatedCallback()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async onClickUpdateReserveExpiration(index: number) {
    const request: UpdateReserveExpirationRequest = {
      id: this.reserveCollections[index].id,
      revision: this.reserveCollections[index].revision
    }

    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await reserveApi.updateReserveExpiration(request)
      await this.updatedCallback()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  onClickDetail(bibliographyId: number) {
    this.modalReserveRank.open(bibliographyId)
  }

  onClickReserveByConfirm() {
    this.reserve()
  }

  async onCompleteForwardingRequest() {
    await this.updatedCallback()

    this.resetInputCollectionNo()
  }

  async getSimpleCollection(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const collections: SimpleCollection[] = await collectionApi.getSimpleCollections(
        {
          collectionNo: this.collectionNo.input
        }
      )

      this.$modalCollectionSelect.open({
        collectionNo: this.collectionNo.input,
        simpleCollections: collections,
        onClickOk: (id: number) => {
          this.inputCollectionId = id
          this.reserveCheck()
        }
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async reserveCheck() {
    this.$eventBus.emit(PAGE_LOADING_START)

    if (this.inputReserve.reserveMethod.input === '3') {
      this.inputReserve.specifyCollectionNo.input = this.collectionNo.input
    }

    try {
      const alerts = await reserveApi.reserveCheck({
        userId: this.userId,
        bibliographies: [],
        collections: [
          {
            id:
              this.inputCollectionId === undefined ? 0 : this.inputCollectionId,
            collectionNo:
              this.inputCollectionId === undefined
                ? this.collectionNo.input
                : ''
          }
        ],
        reserveMethod: this.inputReserve.reserveMethod.input,
        reserveSpecifyBranch:
          this.inputReserve.reserveMethod.input === '2'
            ? this.inputReserve.reserveSpecifyBranch.input
            : [],
        specifyCollectionId:
          this.inputReserve.reserveMethod.input === '3'
            ? this.inputCollectionId
            : undefined,
        specifyCollectionNo:
          this.inputReserve.reserveMethod.input === '3' &&
          this.inputCollectionId === undefined
            ? this.inputReserve.specifyCollectionNo.input
            : '',
        reserveRegistrationBranchCode: this.inputReserve.reserveBranch.input,
        reserveRegistrationPlaceCode: this.inputReserve.reservePlace.input,
        forwardingBranchCode: this.inputReserve.forwardingBranch.input,
        forwardingPlaceCode: this.inputReserve.forwardingPlaceCode.input,
        reserveRegistrationDate: this.inputReserve.reserveRegistrationDate
          .input,
        preferredDate: this.inputReserve.preferredDate.input,
        reserveNoticeAllowed: this.inputReserve.noticeAllowed.input,
        contactMethod: this.inputReserve.contactMethod.input,
        displayMemo: this.inputReserve.memo.input,
        reserveSetId: 0,
        reserveGroupId: 0,
        requestReserve: this.inputReserve.requestReserve.input
      })

      const collections: SimpleCollection[] = await collectionApi.getSimpleCollections(
        {
          collectionNo: this.collectionNo.input
        }
      )

      const inputCollection = collections.find(item => {
        if (this.inputCollectionId === undefined) {
          return item.collectionNo === this.collectionNo.input
        }
        return item.id === this.inputCollectionId
      })

      if (inputCollection !== undefined) {
        this.inputCollectionBibliographyRealId =
          inputCollection.bibliographyRealId
      } else {
        this.inputCollectionBibliographyRealId = 0
      }

      if (alerts.length > 0) {
        alertStore.setItems(alerts)
        this.$modalAlert.open({
          onOkClick: async () => {
            if (this.forwardingRequestEnable) {
              await this.forwardingRequestCheck()
            } else {
              await this.reserve()
            }
          }
        })
      } else if (this.forwardingRequestEnable) {
        await this.forwardingRequestCheck()
      } else {
        await this.reserve()
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        if (
          error.alerts.every((alert: Alert) => alert.code === AlertCodeTL700020)
        ) {
          await this.getSimpleCollection()
          return
        }
        this.setErrorMessage(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async forwardingRequestCheck() {
    console.log('[ModalReserve] forwardingRequestCheck()')

    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const canForwarding = await reserveApi.forwardingRequestCheck({
        userId: this.userId,
        bibliographyId: undefined,
        collectionId: this.inputCollectionId,
        collectionNo:
          this.inputCollectionId === undefined
            ? this.collectionNo.input
            : undefined,
        reserveMethod: this.inputReserve.reserveMethod.input,
        reserveSpecifyBranch:
          this.inputReserve.reserveMethod.input === '2'
            ? this.inputReserve.reserveSpecifyBranch.input
            : [],
        specifyCollectionId:
          this.inputReserve.reserveMethod.input === '3'
            ? this.inputCollectionId
            : undefined,
        specifyCollectionNo:
          this.inputReserve.reserveMethod.input === '3' &&
          this.inputCollectionId === undefined
            ? this.inputReserve.specifyCollectionNo.input
            : undefined,
        reserveRegistrationBranchCode: this.inputReserve.reserveBranch.input
      })

      console.log(
        '[ModalReserve] forwardingRequestCheck() canForwarding =',
        canForwarding
      )
      if (canForwarding) {
        const alert = AlertFactory.create(AlertCodeALC00012, '回送依頼')
        this.forwardingRequestAlerts = [alert]
        this.modalForwardingRequestConfirm.open()
      } else {
        await this.reserve()
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async reserve() {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await reserveApi.reserve({
        userId: this.userId,
        bibliographies: [],
        collections: [
          {
            id:
              this.inputCollectionId === undefined ? 0 : this.inputCollectionId,
            collectionNo:
              this.inputCollectionId === undefined
                ? this.collectionNo.input
                : ''
          }
        ],
        reserveMethod: this.inputReserve.reserveMethod.input,
        reserveSpecifyBranch:
          this.inputReserve.reserveMethod.input === '2'
            ? this.inputReserve.reserveSpecifyBranch.input
            : [],
        specifyCollectionId:
          this.inputReserve.reserveMethod.input === '3'
            ? this.inputCollectionId
            : undefined,
        specifyCollectionNo:
          this.inputReserve.reserveMethod.input === '3' &&
          this.inputCollectionId === undefined
            ? this.inputReserve.specifyCollectionNo.input
            : '',
        reserveRegistrationBranchCode: this.inputReserve.reserveBranch.input,
        reserveRegistrationPlaceCode: this.inputReserve.reservePlace.input,
        forwardingBranchCode: this.inputReserve.forwardingBranch.input,
        reserveRegistrationDate: this.inputReserve.reserveRegistrationDate
          .input,
        preferredDate: this.inputReserve.preferredDate.input,
        reserveNoticeAllowed: this.inputReserve.noticeAllowed.input,
        contactMethod: this.inputReserve.contactMethod.input,
        displayMemo: this.inputReserve.memo.input,
        reserveSetId: 0,
        reserveGroupId: 0,
        forwardingPlaceCode: this.inputReserve.forwardingPlaceCode.input,
        requestReserve: this.inputReserve.requestReserve.input
      })

      await this.updatedCallback()

      this.resetInputCollectionNo()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  forwardingRequest() {
    this.modalForwardingRequest.open()
  }

  setErrorMessage(alerts: Alert[]) {
    alerts.forEach(alert => {
      switch (alert.attribute) {
        case 'collection_ids':
          this.collectionNo.errorMessage = alert.message
          break
        case 'reserve_specify_branch_codes':
          this.inputReserve.reserveSpecifyBranch.errorMessage = alert.message
          break
        case 'specify_collection_no':
          this.inputReserve.specifyCollectionNo.errorMessage = alert.message
          break
        case 'reserve_registration_branch_code':
          this.inputReserve.reserveBranch.errorMessage = alert.message
          break
        case 'reserve_registration_date':
          this.inputReserve.reserveRegistrationDate.errorMessage = alert.message
          break
        case 'reserve_registration_place_code':
          this.inputReserve.reservePlace.errorMessage = alert.message
          break
        case 'preferred_date':
          this.inputReserve.preferredDate.errorMessage = alert.message
          break
        case 'contact_method':
          this.inputReserve.contactMethod.errorMessage = alert.message
          break
        case 'forwarding_branch_code':
          this.inputReserve.forwardingBranch.errorMessage = alert.message
          break
        case 'display_memo':
          this.inputReserve.memo.errorMessage = alert.message
          break
        case 'forwarding_place_code':
          this.inputReserve.forwardingPlaceCode.errorMessage = alert.message
          break
      }
    })
  }

  opened(): void {
    this.$nextTick(() => {
      this.inputCollectionNo.focus()
    })
  }

  closed(): void {
    this.updatedCallback = () => {}
    this.inputReserve = defaultInputReserveItem()
    this.userId = ''
    this.infoItem = defaultUserDetailUserInfoItem()
    this.state = defaultUserDetailStateInfo()
    this.collectionNo = defaultModalSimpleReserveInputCollectionNo()
    this.inputCollectionId = undefined
    this.tableBodyHeight = 0
    this.reserveCancelCollections = []
  }

  onChangeRequestReserveMemo(): void {
    if (this.inputReserve.requestReserve.input) {
      this.inputReserve.memo.input = 'リクエスト予約'
    } else {
      this.inputReserve.memoCode.input = defaultSystemCode()
      this.inputReserve.memo.input = ''
    }
  }
}
